'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./withContainer.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
    className: _propTypes2.default.string,
    svgProps: _propTypes2.default.object
};

exports.default = function (Component) {
    var HoC = function HoC(_ref) {
        var className = _ref.className,
            svgProps = _ref.svgProps,
            rest = _objectWithoutProperties(_ref, ['className', 'svgProps']);

        return _react2.default.createElement(
            'span',
            Object.assign({}, rest, { className: (0, _classnames2.default)('brand-icon', className) }),
            _react2.default.createElement(Component, svgProps)
        );
    };
    HoC.propTypes = propTypes;
    HoC.displayName = 'withBrandIcon(' + Component.name + ')';
    return HoC;
};